import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleAttendanceDegreeType extends TitleBase {
	private degreeTypeValue: string;
	private deliveryMethodValue: string;

	protected canHandle(): boolean {
		this.degreeTypeValue = this.getFilterValue(ParameterType.DEGREE_TYPE);
		this.deliveryMethodValue = this.getFilterValue(ParameterType.DELIVERY_METHOD);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DELIVERY_METHOD) &&
			this.indexableFilters.some((_) => _.type === ParameterType.DEGREE_TYPE)
		);
	}

	protected getPageTitle(): string {
		return `${this.deliveryMethodValue} ${this.degreeTypeValue}`;
	}

	protected getMetaTitle(): string {
		const degreeTypeValue = this.getFilterMetaTitleValue(ParameterType.DEGREE_TYPE);

		return `${this.totalSearchResults} ${this.deliveryMethodValue} ${degreeTypeValue} | ${this.portalName}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`${this.deliveryMethodValue} ${this.degreeTypeValue}`);
	}
}
